/**
 * The assistant's glyph, painted via CSS `mask-image` — `public/sparkles.svg`
 * has a baked `fill="#000000"`, so the shape comes from the file and the colour
 * from `bg-current`, which follows the host's text colour and any hover state
 * for free (the documented pattern for single-colour brand SVGs).
 *
 * Extracted 2026-09-05 when the mobile menu needed the same glyph as
 * <NavChatLink>: `NavChatLink` is an async SERVER component, so a client
 * component cannot import from it, and a second copy of a mask-image block is
 * exactly the drift CLAUDE.md warns about.
 *
 * ⚠️ `size` is deliberately required rather than defaulted. This glyph's ink
 * fills 0.96 of its viewBox height against Phosphor's 0.845, so at an equal
 * nominal size it draws ~13% heavier — each call site has to pick the size that
 * balances the icons it actually sits beside, and `nudge` shifts it optically
 * without expanding its box.
 */
export default function SparklesIcon({ size, nudge = 0 }: { size: number; nudge?: number }) {
  return (
    <span
      aria-hidden="true"
      className="block shrink-0 bg-current"
      style={{
        width: size,
        height: size,
        transform: nudge ? `translateY(${nudge}px)` : undefined,
        WebkitMaskImage: "url(/sparkles.svg)", maskImage: "url(/sparkles.svg)",
        WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
        WebkitMaskPosition: "center", maskPosition: "center",
        WebkitMaskSize: "contain", maskSize: "contain",
      }}
    />
  );
}
